<!-- <div class="modal-header">
  <button
    type="button"
    class="close pull-right"
    aria-label="Close"
    (click)="modalRef.hide()"
  >
    <span aria-hidden="true">×</span>
  </button>
  <h4 class="modal-title w-100" id="myModalLabel">Modal title</h4>
</div>
<div class="modal-body">
  <h5>
    Do you want to hide this city?
  </h5>
  <h5>
    There
    {{
      active_venues == 1
        ? "is 1 active venue"
        : "are " + active_venues + " active venues"
    }}
    associated with this city.
  </h5>
</div>
<div class="modal-footer">
  <div class="btn-group confirm" role="group" aria-label="Basic example">
    <button type="button" class="btn btn-left" (click)="yes()">Yes</button>
    <button type="button" class="btn btn-right" (click)="no()">No</button>
  </div>
</div> -->

<div class="container">
  <div class="modal-header">
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="no()"
    >
      <span aria-hidden="true">X</span>
    </button>
  </div>
  <div class="modal-body">
    <h5>
      Do you want to hide this city?
    </h5>
    <h5>
      There
      {{
        active_venues == 1
          ? "is 1 active venue"
          : "are " + active_venues + " active venues"
      }}
      associated with this city.
    </h5>
  </div>
  <div class="modal-footer">
    <div class="row w-100 no-gutters justify-content-center">
      <button type="button" mdbBtn (click)="yes()" mdbWavesEffect>
        Yes
      </button>
      <button
        type="button"
        mdbBtn
        aria-label="Close"
        (click)="no()"
        mdbWavesEffect
      >
        No
      </button>
    </div>
  </div>
</div>
